import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, PaginationTitle } from "../../../Constants/Constants";
import ActiveDisablePage from "./ActiveDisablePage";
import DefaultPagination from "./DefaultPagination";
import IconPagination from "./IconPagination";
import PaginationAlign from "./PaginationAlign";
import PaginationSize from "./PaginationSize";
import RoundedPagination from "./RoundedPagination";

const PaginationContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={PaginationTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <DefaultPagination />
          <ActiveDisablePage />
          <IconPagination />
          <RoundedPagination />
          <PaginationAlign />
          <PaginationSize />
        </Row>
      </Container>
    </Fragment>
  );
};
export default PaginationContainer;
